module.exports = __webpack_public_path__ + "static/img/stamp_05.62f7ca1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/stamp_05.jpg
// module id = FcUZ
// module chunks = 7